import {Directive, OnDestroy} from '@angular/core';
import {Subject} from 'rxjs';

@Directive()
export abstract class OnDestroySubject implements OnDestroy {
  readonly onDestroy = new Subject();

  ngOnDestroy(): void {
    this.onDestroy.next(null);
  }
}
